import React, { useMemo } from 'react';
import { getTreeLayoutConfig, TreeLayoutTypeEnum, } from './TreeLayoutConfig';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
import { resolveRTLWrapperClassName } from '../../containers/EntityForm/internal/EntityFieldContent';
const TreeContentWrapper = ({ treeLayoutType = TreeLayoutTypeEnum.TREE_TABBED_PAGE, EditComponent = null, isNodeEditVisible = true, children, }) => {
    const { isLayoutRTL } = useLayoutDirection();
    const wrapperClasses = useMemo(() => getTreeLayoutConfig(treeLayoutType), [
        treeLayoutType,
    ]);
    if (isNodeEditVisible && EditComponent) {
        const resolveClassName = (className) => isLayoutRTL && className
            ? resolveRTLWrapperClassName(className)
            : className;
        return (<div className="row">
        <div className={resolveClassName(wrapperClasses.treeClassName)}>
          {children}
        </div>
        <div className={resolveClassName(wrapperClasses.editNodeClassName)}>
          {EditComponent}
        </div>
      </div>);
    }
    return (<div className="row">
      <div className="col-xs-12">{children}</div>
    </div>);
};
export default TreeContentWrapper;
